import api from "../axiosInstance";

/**
 * Auth API Service
 * Updated to match Lumina backend structure
 */

// Login user
export const login = async (email, password) => {
    const res = await api.post("/auth/login", { email, password });

    const data = res.data || {};
    const token = data.token || data.accessToken || data.jwt;

    if (!token) {
        throw new Error("Login response missing token field (expected token/accessToken).");
    }

    return { token, email: data.email };
};

// Register new user
export const register = async (userData) => {
    // Backend expects: firstName, lastName, email, password, repeatPassword
    const response = await api.post("/auth/register", {
        firstName: userData.firstName,
        lastName: userData.lastName,
        email: userData.email,
        password: userData.password,
        repeatPassword: userData.confirmPassword || userData.password // Map confirmPassword to repeatPassword
    });
    return response.data; // Returns: { id, firstName, lastName, email, message }
};

// Get current user info
export const getCurrentUser = async () => {
    const response = await api.get("/auth/me");
    return response.data; // Returns: { email, message }
};

// Verify token (uses /auth/me endpoint)
export const verifyToken = async () => {
    const response = await api.get("/auth/me");
    return response.data;
};

// Request password reset (not implemented in backend yet)
export const requestPasswordReset = async (email) => {
    const response = await api.post("/auth/forgot-password", { email });
    return response.data;
};

// Reset password with token (not implemented in backend yet)
export const resetPassword = async (token, newPassword) => {
    const response = await api.post("/auth/reset-password", { token, newPassword });
    return response.data;
};